const translationLocalEN = {
  T_HIDE: "hide",
  T_VIEW: "view",
  T_CANCEL: "Cancel",
  T_RESET: "Reset",
  T_EDIT: "Edit",
  T_SAVE: "Save",
  T_EXPORT: "Export",
  T_EMAIL: "Email",
  T_SMS: "SMS",
  T_PUSH: "Push",
  T_BACK: "Back",
  T_CLOSE:"Close",
  T_EXPIRES_IN: "Expires in:",
  T_PASSWORD_TO_REMEMBER: "Passwords to remember:",
  T_PASSWORD_POLICY_NAME: "Password Policy Name",
  T_PASSWORD_POLICY_CANNOT_BE_EMPTY: "Password policy name cannot be empty",
  T_PASSWORD_POLICY_ALREADY_EXISTS:
    "That password policy name is taken. Try another.",
  T_PASSWORD_POLICY_CREATE_SUCCESS: "Password policy created successfully.",
  T_PASSWORD_POLICY_UPDATE_SUCCESS: "Password policy %s updated successfully.",
  T_PASSWORD_POLICIES: "Password Polices",
  T_BACK_TO_PASSWORD_POLICIES: "Back to Password Polices",
  T_PASSWORD_POLICY_BY_NAME: "Search password policy by name",
  T_NEW_ROLE: "New Role",

  T_SHOWING: "Showing",

  T_TOAST_MSG_PART1: "No default",
  T_TOAST_MSG_PART2: "defined. Please contact your IT administrator.",
  T_TOAST_ERR_MSG_PART1: "Failed to fetch",
  T_TOAST_ERR_MSG_PART2: ". Please contact your IT administrator.",
  T_ORGANIZATION: "Organization",
  T_PASSWORD: "Password",
  T_FORGOT_PASSWORD: "Forgot Password?",
  T_CAPS_LOCK_ON: "Caps Lock is on",
  T_REMEMBER_USERNAME: "Remember username",
  T_SIGN_IN: "Sign in",
  T_FIRST_NAME: "First Name",
  T_LAST_NAME: "Last Name",

  T_ROLE: "Role",
  T_DESCRIPTION: "Description",
  T_ORGANIZATION_NAME: "Organization Name",
  T_EMAIL_ADDRESS: "Email Address",
  T_USERNAME: "Username",
  T_NEVER_REMEMBER: "Never remember",
  T_ACTIONS: "Actions",
  T_MY_ACCOUNT: "My Account",
  T_SIGN_OUT: "SIGN OUT",
  T_NEW_PASSWORD: "New Password",
  T_CONFIRM_PASSWORD: "Confirm Password",
  T_SET_NEW_PASSWORD: "Set new password",
  T_CURRENT_PASSWORD: "Current Password",

  T_NEVER_TIME_OUT: "Never times out",

  T_BACK_TO_NOTIFICATION_BTN: "Back to Notification list",
  T_BACK_TO_ORGANIZATION_LIST_BTN: "Back to organization list",

  T_ERROR_NOT_FOUND: "404 - Not found",
  T_ERROR_SOMETHING_WRONG: "something went wrong.",

  T_SEARCH_PLACEHOLDER_HINT: "Search by template name",
  T_SEARCH_ROLE_NAME_PLACEHOLDER: "Search by role name",
  T_SEARCH_USER_NAME: "search by user firstname",
  T_SEARCH_ORG_NAME: "Search by organization name",
  T_SEARCH_BY_PERMISSION_SET: "Search permission set",
  T_SEARCH_NAME: "Search with name",
  T_SEARCH_ERROR: "Search string can not be more than 256 characters",
  T_SEARCH_NAME_FIELDGROUP: "Search by fieldgroup name",

  T_DELETED_SUCCESS_MESSAGE: "deleted successfully.",
  T_TEMPLATE_SAVED_SUCCESS_MSG: "Template saved successfully",
  T_TEMPLATE_CREATED_SUCCESS_MSG: "Template created successfully",
  T_DEFAULT_ALL_NOTIFICATION_TEMPLATE: "Default view: All Channel types",
  T_ROLE_CREATED_SUCCESS_MSG: "Role created successfully.",
  T_ROLE_FIELD_MAX_LIMIT_ERROR:
    "Characters in Role name and description should be less than 1024",
  T_ROLE_UPDATE_SUCCESS_MSG: "Role updated successfully.",
  T_ORG_CREATED_SUCCESS_MSG: "Organization Created Successfully",
  T_CHANGE_PASSWORD_SUCCESS_MSG: "Password Changed Successfully",
  T_UPDATE_SUCCESS_MSG: "updated Successfully.",
  T_LOGOUT_MSG: "user logged out",

  T_FAILED_CREATE_SESSION_MSG: "Failed to create session context.",
  T_FAILED_CREATE_MSG: "creation failed.",

  T_ERROR_MSG_FOR_SHOW_PERMISSION_SET:
    "Unable to fetch application feature data. Please contact your administrator.",

  T_VALIDATION_ERR_EMAIL_MSG: "Please enter a valid email address",
  T_VALIDATION_ERR_EMPTY_MSG: "Field should not be empty",
  T_VALIDATION_ERR_POST_CODE_MSG: "Postal Code should be of 5 digits only.",
  T_VALIDATION_ERR_FOR_PASSWORD_INVITE_CODE: "Must enter an invite code.",
  T_VALIDATION_ERR_PASSWORD_POLICY_MSG1: "Must contain at least",
  T_VALIDATION_ERR_PASSWORD_POLICY_MSG2: "characters",
  T_VALIDATION_ERR_PASSWORD_POLICY_MSG3:
    "Must contain atleast 1 character from",
  T_VALIDATION_ERR_PASSWORD_POLICY_MSG4: "Must contain special character",
  T_VALIDATION_ERR_PASSWORD_POLICY_MSG5: "Passwords do not match.",

  T_CARD_ALT_MESSAGE: "organization icon image",
  T_DESC_FOR_ORG_CREATE_BUCKET:
    "Automated bucket created by Admin Portal for organization:",
  T_DESC_FOR_PERMISSION_HEADER: "Permission Set Name",
  T_DESC_FOR_APP_ROLE_ASSIGNED: "Application Role Assigned",

  T_LBL_FOR_PERMISSION_SET_DETAILS: "Permission set details",
  T_LBL_APPLICATION_FEATURES: "Application Features",
  T_LBL_FOR_USER_PORTAL_FEATURES: "Admin Portal Features",
  T_LBL_FOR_OTHERS_SETTINGS: "Other Settings",
  T_APP_SETTINGS: "App Settings",
  T_LBL_FOR_SETTINGS_JSON: "Settings JSON",

  T_WARN_MSG_PART1: "No category:",
  T_WARN_MSG_PART2: "added to organization:",

  T_REQUIRED_CONSTRAINT_ERROR:
    "Can not increase the scope from not required to required",
  T_LOGIN_ERROR_MESSAGE: "Not able to sign in, Please try again",
  T_LOGIN_TOAST_MESSAGE:
    "Account successfully created. Please sign in to begin using the portal",
  T_LOGIN_TOAST_FAILURE: "Login failure",
  T_TOAST_NOTIFICATION_OTP_MSG:
    "You will receive One Time Password on valid registered email.",
  T_TOAST_NOTIFICATION_FOR_NEW_CODE_SEND:
    "A new code has been sent to your email id.",
  T_TOAST_NOTIFICATION_FOR_CREATED_ACCOUNT_SUCCESS_MSG:
    "Account successfully created. Please sign in to begin using the portal.",
  T_TOAST_NOTIFICATION_ERR_MSG: "Password is already created for this email",
  T_TOAST_ORGANIZATION_CREATE_SUCCESS: "Organization created successfully",

  T_LOGIN_HEADING: "Sign in to your account",
  T_LOGIN_SUB_HEADING: "Please enter your App credentials to proceed",
  T_LOGIN_SPLASH_MESSAGE1: "Data Subject Request Portal",
  T_LOGIN_SPLASH_MESSAGE2: "Forgot your password?",
  T_LOGIN_SPLASH_MESSAGE3: "Code + New Password",
  T_LOGIN_ALERT_MESSAGE:
    "Your account has been locked due to too many failed attempts. Please contact your system administrator.",
  T_LOGIN_IMAGE_BARS_ALT_MESSAGE: "bars",
  T_LOGIN_IMAGE_ADMIN_PORTAL_ALT_MESSAGE: "AdminPortal",

  T_ROLE_DETAILS: "Role Details",
  T_ROLE_DETAIL_CARD_TITLE: "Application Role Details",
  T_ROLE_DETAILS_BACK_TO_ROLE_BTN: "Back to Roles list",
  T_ROLE_DETAIL_SECURITY_CARD_TITLE: "Application Role Security",
  T_ROLE_DETAIL_SECURITY_OPTIONS_TITLE: "Account Security Options",
  T_ROLE_API_PERMISSIONS: "API Permissions",
  T_ROLE_API_PERMISSIONS_AVAILABLE: "Available API Permissions",
  T_ROLE_API_PERMISSIONS_SELECTED: "Selected API Permissions",

  T_USER_DETAIL_TITLE: "User Details",
  T_USER_CARD_ALT_MESSAGE: "admin icon image",
  T_ORG_DETAIL_TITLE: "Organization Details",
  T_STEPS_INSTRUCTIONS_FOR_CREATE_ORG_MSG:
    "Complete the following steps to activate this organization:",

  T_TRUE: "True",
  T_FALSE: "False",

  T_DUALING_LIST_DEFAULT_SEARCH_PLACEHOLDER: "Search permission",

  T_PHONE: "Phone",
  T_NEW_ORGANIZATION: "New Organization",
  T_CREATE_CHILD_ORGANIZATION: "Create Child Organization",
  T_NAME: "Name",
  T_LABEL: "Label",
  T_FAX: "Fax",
  T_ADDRESS: "Address",
  T_CITY: "City",
  T_STATE: "State",
  T_ZIP: "Zip",
  T_COUNTRY: "Country",
  T_TYPE: "Type",
  T_APPLICATION_ROLE_NAME: "Application Role Name",
  T_MULTI_FACTOR_AUTHENTICATION: "Multi-Factor Authentication",
  T_LOCATION_HEURISTICS: "Enable Location Heuristics",
  T_PERMISSION_SET: "Permission Set",
  T_SELECT: "Select",
  T_ROLE_DESCRIPTION: "Role Description",
  T_DESC_PERMISSION_SET: "Name of permission set",
  T_DESC_PERMISSION_DESCRIPTION:
    "Describe what this permission set allows this user to do",
  T_VALIDATION_ERR_PASSWORD_MSG1: "8 or more characters",
  T_VALIDATION_ERR_PASSWORD_MSG2: "Upper & lowercase letters",
  T_VALIDATION_ERR_PASSWORD_MSG3: "At least one number",
  T_VALIDATION_ERR_PASSWORD_MSG4: "At least one special character (e.g. $#!”)",

  T_MENU_ORGANIZATION: "Organization MGM",
  T_MENU_CONFIGURATION: "Configuration Service",
  T_MENU_USER_MANAGEMENT: "User Role and Password",
  T_MENU_APPLICATION_CONTEXT: "Application Context",
  T_MENU_APP_FEATURE: "App Feature",
  T_MENU_COMMUNICATION_TEMPLATE: "communication Template",
  T_MENU_PATIENT_DATA: "Patient Data",
  T_MENU_RULE_CONFIGURATION: "Rule Configuration",
  T_MENU_SURVEY_CREATION: "survey creation",
  T_ROCHE_ADMIN_TITLE_CUSTOMERS: "customers",
  T_CUSTOMER_ADMIN_TITLE_FOR_CLINICS: "clinics",
  T_CUSTOMER_ADMIN_TITLE_FOR_ADMIN: "admins",
  T_CUSTOMER_STEPPER_DESCRIPTION: "Enter Email",
  T_CUSTOMER_STEPPER_CODE_PLUS_PASSWORD: "Code + Password",
  T_CUSTOMER_STEPPER_EXPLORE: "Explore",
  T_ACTIVE: "Active",
  T_NOT_ACTIVE: "Not Active",
  T_BUCKET_MSG: "This bucket is ",

  T_COOKIES_TITLE: "Cookies",
  T_COOKIES_ALT_MSG: "Password Lock Icon",
  T_COOKIES_TEXT_MSG: "Allow site to save and read cookie data (recommended)",
  T_LANGUAGE_ADD_BUTTON: "Add New Language",
  T_LANGUAGE_RULE_ADD_BUTTON: "Add New Rules Language Pack",
  T_LANGUAGE: "Language",
  T_LANGUAGE_DETAILS: "Language Details",
  T_LANGUAGE_NAME: "Language Name",
  T_LANGUAGE_PICKER_TITLE: "Picker Title",
  T_LANGUAGE_PICKER_BUTTON_TITLE: "Picker Button Title",
  T_LOCALE: "Locale Name",
  T_LOCALE_EXISTING_ERROR: "This Locale already exists",
  T_DELETE_LANGUAGE_CONTENT: "Do you want to delete this language?",

  T_PASSWORD_LOCK_ICON: "Password Lock Icon",
  T_LANGUAGE_TEXT: "Set your language for this portal",
  T_CHANGE_LANGUAGE: "Change Language?",
  T_TIMES_ICON_ALT_MSG: "close",
  T_CHANGE_LANGUAGE_MSG:
    "Your clinician portal language will convert from English to Español.",
  T_OK: "OK",
  T_PROFILE_INFORMATION: "Profile Information",
  T_ADMIN_ICON_ALT_MSG: "admin icon image",
  T_PHONE_NUMBER: "Phone Number",
  T_SAVE_CHANGES: "Save Changes",
  T_PROFILE_INFORMATION_CARD_TITLE: "Organization Details",
  T_PROFILE_UPLOAD_IMAGE: "profile upload image",
  T_UPLOAD_PHOTO: "Upload Photo",
  T_RULE_MAX_PHOTO_SIZE: "Max upload size: 3MB",
  T_RULE_FILE_TYPE_SUPPORT: "Files supported: JPG, PNG, SVG",
  T_RULE_PHOTO_RESOLUTION: "File resolution must be 250 x 70 pixels or larger",
  T_TOAST_NOTIFICATION_ALT_MSG: "Check Image",
  T_TOAST_NOTIFICATION_PASSWORD_SUCCESS: "Password successfully updated.",
  T_CLOSE_ICON_ALT_MSG: "Close Button",
  T_USER: "User",
  T_TOAST_DEACTIVATED_MSG: "is deactivated successfully.",
  T_TOAST_RE_INVITED_MSG: "is reinvited successfully.",
  T_DEACTIVATE_TITLE:
    "This member will no longer have access and will be permanently removed from the system.",
  T_BUTTON_YES_DEACTIVATE: "Yes, Deactivate",
  T_BUTTON_YES_ACTIVATE: "Yes, Activate",
  T_RE_INVITE_USER: "Reinviting user",
  T_BUTTON_YES_RE_INVITE: "Yes, Reinvite",
  T_DEACTIVATE_ACCOUNT: "Deactivate Account",
  T_DEACTIVATE_ACCOUNT_MSG:
    "This member will no longer have access to the portal.",
  T_BUTTON_RE_INVITE_USER: "Reinvite User",
  T_DEACTIVATE_USER: "Deactivate User",
  T_IS_UPDATE_SUCCESS_MSG: "is updated successfully.",
  T_STATUS: "Status",
  T_TOAST_MESSAGE_APP_SETTINGS_SUCCESS:
    "Application settings updated successfully.",
  T_FORMAT_JSON: "Format JSON",
  T_IMPORT_JSON: " Import JSON",
  T_PASSWORD_MATCH_MSG: "Passwords should Match",
  T_SESSION_TIMEOUT: "Session timeout",
  T_SESSION_TIMEOUT_MSG1: "Your session will timeout due to inactivity in",
  T_SESSION_TIMEOUT_MSG2: "minutes and",
  T_SESSION_TIMEOUT_MSG3: "seconds.",
  T_BUTTON_SESSION_PRIMARY_TITLE: "Stay signed in",
  T_VALIDATION_AUTH_NEEDED_MSG: "Incorrect email address or password.",
  T_VALIDATION_SETTINGS_LENGTH_MSG: "No application configuration defined for",
  T_APP_SETTINGS_MISSING_MSG: "Missing application settings",
  T_VERIFICATION_ALERT_TOAST_MSG1:
    "A new code has been sent. Code expires in 24 hours.",
  T_VERIFICATION_ALERT_TOAST_MSG2:
    "Request limit exceeded. Contact your admin for support.",
  T_VALIDATION_ERR_EXPIRED_CODE_MSG: "Invalid or expired code. Try again.",
  T_STATUS_LOADING_IN_MSG: "Logging In...",
  T_BUTTON_SIGN_IN_SECURELY: "Sign in securely",
  T_BUTTON_REQ_FOR_NEW_CODE: "Request a new code",
  T_BUTTON_RETURN_TO_SIGN_IN_PAGE: "Return to Sign in page",
  T_PROFILE: "Profile",
  T_ROLE_MANAGEMENT: "Role Management",
  T_NOTIFICATION_TEMPLATES: "Notification Templates",
  T_USERS: "Users",
  T_DELETED_CONTRACT_SUCCESS_MSG: "Contract deleted successfully",
  T_CONTRACT: "Contract",
  T_VERSION: "Version",
  T_CATEGORY: "Category",
  T_UPLOAD_BY: "Uploaded By",
  T_DATE_AND_TIME: "Date/Time",
  T_ADMIN_PORTAL: "AdminPortal",
  T_VALIDATION_DUPLICATE_BUCKET_MSG1: "Filename Error: The name of the file",
  T_VALIDATION_DUPLICATE_BUCKET_MSG2: "already exists",
  T_VALIDATION_DUPLICATE_BUCKET_MSG3: "is invalid",
  T_AMS_PARAM_DUPLICATE_FILE_MSG: "File with the same name already exists.",
  T_FILES_UPLOAD_PARTIAL_SUCCESS: "%s/%d assets uploaded successfully.",
  T_FILES_UPLOAD_ALL_FAILURE: "%s/%d assets failed to upload.",
  T_FILE_UPLOAD_SUCCESS: "%s assets uploaded successfully.",

  T_VALIDATION_DUPLICATE_BUCKET_MSG4: "Unknown Error for the file",
  T_NO_FILE_CHOSEN: "No files chosen",
  T_HEALTH_SYSTEM: "Health System",
  T_NO_DATA_AVAILABLE_MSG: "No data available. Insert some records.",
  T_NO_SEARCH_DATA_MSG: "Start typing for relevant results.",
  T_CONTRACTS: "Contracts",
  T_UPLOAD_NEW_CONTRACT: "Upload New Contracts",
  T_CONTRACT_UPLOAD_SUCCESS_MSG: "Contracts uploaded successfully.",
  T_NOT_UPLOADED: "not uploaded",
  T_MANAGE_CONTRACT: "Manage Contracts",
  T_VALIDATION_ERR_EMAIL_EXITS_MSG: "This email already exists",
  T_VALIDATION_ENTER_VALID_EMAIL_MSG: "Please enter a valid email address",
  T_VALIDATION_ERR_NAME_MSG: "Name should not contain special characters.",
  T_VALIDATION_SELECT_USER_ROLE_MSG: "Please select a user role.",
  T_BUTTON_UPDATE: "Update",
  T_BUTTON_ADD: "Add",
  T_ADMIN_INVITED_SUCCESS_MSG: "admin(s) invited successfully.",
  T_EDIT_ORGANIZATION_DETAILS: "Edit Organization Details",

  T_PARENT: "Parent",

  T_MANAGE_ORGANIZATION: "Manage organization",
  T_UPPERCASE: "Upper case",
  T_LOWERCASE: "Lower case",
  T_DIGITS: "Digits",
  T_PASSWORD_POLICY: "Password Policy",
  T_NEW_PASSWORD_POLICY: "New Password Policy",
  T_SEARCH_PASSWORD_POLICY_BY_NAME: "Search password policy by name",
  T_PASSPORT_POLICY_HINT_MSG1: "Your Password must include:",
  T_PASSPORT_POLICY_HINT_MSG2: "or more characters.",
  T_AT_LEAST: "Atleast",
  T_ENTER_CODE: "Enter code",
  T_REGISTER_ENTER_CODE_MSG:
    "Please enter the code found in your invitation email that was sent to",
  T_INVITE_CODE: "Invite Code",
  T_CREATE_PASSWORD: "Create Password",
  T_CHANGE_PASSWORD: "Change Password",
  T_DONE: "Done",
  T_UPDATE: "Update",
  T_CREATE_YOUR_ACCOUNT: "Create your account",
  T_REMEMBER_PASSWORD: "Passwords to remember",

  T_ON: "On",
  T_OFF: "Off",
  T_PASSWORD_CHECK_MSG_FOR_SPECIAL_CHARS:
    "Requires at least one special character (@#!*)",
  T_PASSWORD_CHECK_FOR_AT_LEAST_ONE_NUM: "Requires at least one number",
  T_PASSWORD_CHECK_ONE_UPPER_CASE_MSG: "Requires at least one uppercase letter",
  T_PASSWORD_CHECK_ONE_LOWER_CASE_MSG: "Requires at least one lowercase letter",

  T_SELECT_ONE: "Select One.",

  T_ID: "ID",
  T_SUBJECT: "Subject",
  T_BODY: "Body",
  T_LAST_MODIFIED: "Last Modified",
  T_TEMPLATES: "Templates",
  T_VALIDATION_CHECK: "Validation Check",
  T_TASK_TRACKER_ALT_MSG: "task completed",
  T_TASK_FAILURE_ALT_MSG: "task failure",
  T_TASK_INCOMPLETE_ALT_MSG: "task incompleted",
  T_CONSOLE_ERROR_MSG: "Empty session switch context...Failed",
  T_SWITCH_SESSION_EMPTY_SESSION_MSG: "Empty session switch context",
  T_SESSION_EMPTY_MSG: "Logged in user session context is empty",
  T_NO_DEFAULT_TEMPLATES_AVAILABLE:
    "No default templates present in parent organization",
  T_ERROR_BOUNDARY_MSG: "Algo deu errado.",
  T_VALIDATION_INPUT_ERR_EMPTY_MSG: "Field can not be left empty.",
  T_VALIDATION_INPUT_ERR_ONLY_NUMBER_MSG: "Field should contain only numbers.",
  T_VALIDATION_ERR_CONTACT_NUMBER: "Number should be of 10 digits only.",
  T_VALIDATION_ERR_TEXT_LENGTH_CUSTOM_MSG:
    'Text too long. Max length "${LENGTH}" characters.',
  T_VALIDATION_ERR_TEXT_LENGTH_MSG: "Text too long. Max length 255 characters.",
  T_VALIDATION_ERR_TEXT_TOO_LONG_MSG:
    "Text too long. Max length 1024 characters.",
  T_USER_IS_MSG: "User is",
  T_NEXT:"Next",
  T_PREVIOUS: "Previous",
  T_ALREADY_USED: "this email is already in use",
  T_TWO_STEP_VERIFICATION: "Two-step verification",
  T_TWO_STEP_VERIFICATION_MSG:
    "A verification code has been sent. Please enter the code below to continue.",
  T_ENGLISH: "English (US)",
  T_FRENCH: "French",
  T_SPANISH: "Spanish",
  T_CONTINUE: "Continue",
  T_ONE_TIME_OTP_ENTER: "Enter your One-Time Password sent to",
  T_NOT_RECEIVED_LBL: "Didn’t receive an email?",
  T_NOT_RECEIVED_MSG:
    "Be sure to check your spam folder before requesting a new code",
  T_RECEIVE_OTP_EMAIL_HELP_MSG:
    "Enter your email to receive a One-Time Password (OTP) to reset your password.",
  T_REQ_NEW_OTP: "Request a new OTP",
  T_BREADCRUMB_SHOW_PERMISSION_LBL: "Security > Permission Sets > View",
  T_INVALID_EMAIL: "Invalid Email",

  T_ADD_OPTION: "Add option",
  T_DEFAULT_OPTION_SELECTED: "Set as default",
  T_REMOVE_OPTION: "Remove option",
  T_CREATED_BY: "Created by",
  T_CREATED_ON: "Created on",
  T_UPDATED_BY: "Updated by",
  T_UPDATED_ON: "Updated on",
  T_USER_NO_PERMISSION_TOAST_MESSAGE:
    "User do not have permission to view Permission",

  T_PROPERTIES: "Properties",
  T_YES: "Yes",
  T_NO: "No",

  T_REQUIRED: "Required?",
  T_IS_REQUIRED: "Required",
  T_ALLOW_EDITS: "Allow Edits?",
  T_EDITABLE: "Editable",
  T_SEARCHABLE: "Searchable",
  T_SORTABLE: "Sortable",
  T_IS_SEARCHABLE: "Searchable?",
  T_IS_SORTABLE: "Sortable?",
  T_HASH_OF_CHARATERS: "# of Charaters",
  T_MAX_HASH: "Max #",
  T_MIN_HASH: "Min #",
  T_MAX_LENGTH: "Max Length",
  T_MAX: "Max",
  T_MIN: "Min",
  T_MAX_VALUE: "Max Value",
  T_MIN_VALUE: "Min Value",

  T_CATEGORY_REMOVE: "Remove",
  T_CONFIRM: "Confirm",

  T_DELETE: "Delete",
  T_COUNTRY_CODE: "C-Code",
  T_INVALID_CURRENT_PASSWORD_TEXT: "Current password is not correct.",
  T_SESSION_TIMEOUT_HEADER: "Session timeout",
  T_SESSION_TIMEOUT_BODY_TEXT: "Your session will timout due to inactivity in ",
  T_SESSION_STAY_SIGNED_IN: "Stay signed in",
  T_SESSION_SIGN_OUT: "Sign out",

  T_ADD: "Add",
  T_UPLOAD: "Upload",
  T_KEY: "Key",
  T_VALUE: "Value",
  T_ADD_ITEM: "Add Item",

  T_NEW_CAREPLAN: "New Care Plan",
  T_CREATE_REQUEST: "Create Request",
  T_CREATE_REQUEST_HELPER:"Please complete the form below to exercise your rights under local privacy law. We are committed to handling your request promptly and securely.",
  T_PAST_REQUESTS: "Past Requests",
  T_REQUEST_HISTORY: "Request History",
  T_PATIENT_REQUESTS: "Data Subject Request",
  T_NEW_PATIENT_REQUEST_HEADER: "Create Request",
  T_NEW_PATIENT_REQUEST_NAME: "Patient Name",
  T_NEW_PATIENT_REQUEST_EMAIL: "Patient Email",
  T_NEW_PATIENT_REQUEST_CREATE_REQUEST: "Create Request",
  T_NEW_PATIENT_REQUEST_TYPE: "Data Request Type",
  T_NEW_PATIENT_REQUEST_TYPE_REQUEST: "Data Request",
  T_NEW_PATIENT_REQUEST_TYPE_EXPORT: "Data Export",
  T_NEW_PATIENT_REQUEST_TYPE_RECTIFICATION: "Data Rectification",
  T_NEW_PATIENT_REQUEST_TYPE_RECTIFICATION_MESSAGE: "Rectification Message",
  T_NEW_PATIENT_REQUEST_TYPE_DELETION: "Data Deletion",
  T_NEW_PATIENT_REQUEST_TYPE_RESTRICTION: "Data Restriction",
  T_NEW_PATIENT_REQUEST_TYPE_RESTRICTION_HEADER: "Data Restriction Type",
  T_NEW_PATIENT_REQUEST_TYPE_RESTRICTION_ENABLE: "Enable Restriction",
  T_NEW_PATIENT_REQUEST_TYPE_RESTRICTION_DISABLE: "Disable Restriction",
  T_NEW_PATIENT_REQUEST_ADDTIONAL_MESSAGE: "Additional Message (Optional)",
  T_GDPR_REQUEST_SUBJECT: "GDPR Request",

  //GDPR FIELD TRANSLATIONS
  "Creator Name": "Requested by",
  "Subject's Name":"Subject's Name",
  "Username":"Username",
  "Request Type":"Request type",
  "Additional Message (Optional)":"Additional message (optional)",
  "Data Request":"Data Request",
  "Data Export":"Data Export",
  "Data Rectification":"Data Correction",
  "Recification Message":"Correction Message",
  "Data Deletion":"Data Deletion",
  "Data Restriction": "Data Restriction (may disable some services)",
  "Restriction Type":  "Restriction Type",
  "Enable Restriction":"Enable Restriction",
  "Disable Restriction":"Disable Restriction",

  "Subject's Name_HELPER":"Who is this request for",
  "Username_HELPER": "Subject username",
  "Additional Message (Optional)_HELPER":"Optional message",
  "Request Type_HELPER":"Select a type of request",
  "Rectification Message_HELPER":"What do you want corrected?",
  "Restriction Type_HELPER":  "Select",

  T_AUTOCOMPLETE_DEFAULT_SEARCH_TEXT: "Search or add manually",
  T_TICKET_CREATED_SUCCESS: "Request created successfully",
  T_TICKET_CREATION_FAILURE: "Request creation failed.",
  T_ZENDESK_REQUESTED_FOR: "Requested For",
  T_CONFIRM_DETAILS_SUB: "Are you sure you want to submit the request?",
  T_VIEW_REQUEST: "View Request",
  T_NEW_REQUEST: "New Request",
  T_SOLVED: "Solved",
  T_NEW: "New",
  T_OPEN: "Open",
  T_PENDING: "Pending",

  T_CUSTOMIZATION: "Customization",
  T_CUSTOMIZATION_TYPE: "Select asset",
  T_CUSTOMIZATION_OPTION_BANNER_LOGO: "Logo Icon",
  T_CUSTOMIZATION_OPTION_BANNER_IMG: "Banner Image",
  T_CUSTOMIZATION_OPTION_SPLASH_IMG: "Splash Image",
  T_CUSTOMIZATION_OPTION_THEME: "Theme Pack",
  T_CUSTOMIZATION_TYPE_INFO:
    "Download the selected asset or upload an updated one",
  T_CUSTOMIZATION_NO_PREVIEW: "No Preview Available",
  T_CUSTOMIZATION_UPDATE_SUCCESS: "Asset updated successfully.",
  T_STYLING_UPDATE_SUCCESS: "Styles updated successfully.",
  T_FILE_ADDED: "Asset added.",
  T_DROP_DRAG_FILE_MSG: "Drag and drop asset here or",
  T_UPLOAD_FROM_COMPUTER: "upload from your computer",
  T_ASSETS: "Assets",
  T_CUSTOMIZATION_ASSETS: "Assets Customization",
  T_CUSTOMIZATION_THEME: "Theme Customization",
  T_THEME_STYLING: "Theme Styling",

  T_COLOUR_PALETTE: "Colour Palette",
  T_PRIMARY_CHOICE: "Primary Colour Choice",
  T_PRIMARY_CHOICE_DESC:
    "This applies to buttons, sign-out icons, primary theme.",
  T_SECONDARY_CHOICE_1: "Secondary Colour Choice 1",
  T_SECONDARY_CHOICE_1_DESC:
    "This applies to menu background, selected menu icons, page title.",
  T_SECONDARY_CHOICE_2: "Secondary Colour Choice 2",
  T_SECONDARY_CHOICE_2_DESC:
    "This applies to section headers, dropdown items, page background colours.",

  T_COLOUR_DISABLED: "Disabled Colours",
  T_PRIMARY_DISABLED_CHOICE: "Primary Disabled Colour Choice",
  T_PRIMARY_DISABLED_CHOICE_DESC:
    "This applies to all disabled elements assigned primary theme.",
  T_SECONDARY_DISABLED_CHOICE: "Secondary Disabled Colour Choice",
  T_SECONDARY_DISABLED_CHOICE_DESC:
    "This applies to all disabled elements assigned secondary theme",

  T_COLOUR_HOVER: "Hover Colours",
  T_PRIMARY_HOVER_CHOICE: "Primary Hover Colour Choice",
  T_PRIMARY_HOVER_CHOICE_DESC:
    "This applies to all elements assigned primary theme.",
  T_SECONDARY_HOVER_CHOICE: "Secondary Hover Colour Choice",
  T_SECONDARY_HOVER_CHOICE_DESC:
    "This applies to all elements assigned secondary theme.",

  T_COLOUR_TEXT: "Text Colours",
  T_PRIMARY_TEXT_CHOICE: "Primary Text Colour Choice",
  T_PRIMARY_TEXT_CHOICE_DESC:
    "This applies to all text corresponding to primary theme.",
  T_SECONDARY_TEXT_CHOICE: "Secondary Text Colour Choice",
  T_SECONDARY_TEXT_CHOICE_DESC:
    "This applies to all text corresponding to secondary theme.",

  T_ASSET_LOGO_DESCRIPTION: "This icon is displayed on the browser tab logo",
  T_ASSET_BANNER_DESCRIPTION:
    "This image is displayed on top left of the each page. Ideal for brand logo(s)",
  T_ASSET_SPLASH_DESCRIPTION:
    "This image represents the Data Request Portal itself. Only visible on the login page",

  T_GDPR:"GDPR",
  T_LANGUAGE_PACKS: "Language Packs",
  T_LANGUAGE_UPDATED_SUCCESS: "Language Pack updated successfully.",
  T_ABOUT_GDPR_LAWS: "About Data Subject Rights",
  T_VALID_LOCALE_FORMAT: `%s is not a valid locale. Please use a valid locale format, such as "en-US".`,
  T_GDPR_RULES:"Data Subject Rights",
  T_LANGUAGE_RULE_PACKS: "Rules Language Packs",
  T_LANGUAGE_RULE_UPDATED_SUCCESS: "Rules Language Pack updated successfully.",
  T_LANGUAGE_DISCLAIMER_UPDATED_SUCCESS: "Rules Language Pack updated successfully.",
  T_LANGUAGE_ADVERSE_UPDATED_SUCCESS: "Data Requests Adherence Language Pack updated successfully.",
  T_LANGUAGE_SELECT:"Select a language",
  T_SETTINGS: "Settings",
  T_ROWS_PER_PAGE:"Rows per page",
  T_MENU:"Menu",
  T_PRIVACY_POLICY:"Privacy Policy",
  T_PRIVACY_POLICY_LABEL:"Please enter the URL for Privacy Policy",
  T_DISCLAIMER_POLICY:"Disclaimer Policy",
  T_LANGUAGE_DISCLAIMER_ADD_BUTTON: "Add New Disclaimer Policy Language Pack",
  T_ADVERSE_POLICY:"Data Requests Adherence Policy",
  T_LANGUAGE_ADVERSE_ADD_BUTTON: "Add New Data Requests Adherence Language Pack",
  T_POLICIES:"Policies",
  T_ENTER_VALID_PRIVACY_URL:"Please enter a correct URL",
  T_PRIVACY_URL_UPDATED_SUCCESS: "Privacy Policy URL was updated successfully",
  T_APPLICATION_PRIVACY_LABEL:"Application Privacy Notice",
  T_CREATE_REQUEST_PROMPT_P1:"Please read the",
  T_DISCLAIMER:"Disclaimer",
  T_AND:"&",
  T_ADVERSE_EVENT:"Adverse Event Policy",
  T_CREATE_REQUEST_PROMPT_P2:"before submitting a request",
  T_PAGE_UNAVAILABLE_HEADER:"Page Not Found",
  T_PAGE_UNAVAILABLE_BODY_L1:"We couldn't find the page you were looking for.",
  T_PAGE_UNAVAILABLE_BODY_L2:"This may be the result of an old link or a moved page.",
  T_PAGE_UNAVAILABLE_BODY_L3:"We apologize for the inconvenience.",
  T_PAGE_UNAVAILABLE_CONTACT_P1:"Please",
  T_PAGE_UNAVAILABLE_CONTACT_P2:"contact us",
  T_PAGE_UNAVAILABLE_CONTACT_P3:"for more information.",
  T_GDPR_PORTAL: "GDPR Portal"
};

export default translationLocalEN;
